export default "__VITE_ASSET__BRLlPL1D__"